module.exports = __webpack_public_path__ + "static/media/icon-export.cf36c648.svg";